import React, { useState } from "react";
import { galleryImages } from "../data/mock";
import { useReveal } from "../hooks/useReveal";
import { X, Camera } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function Gallery() {
  const { t } = useLanguage();
  const r = useReveal();
  const [selected, setSelected] = useState(null);

  return (
    <section id="gallery" className="py-24 bg-cream relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={r.ref} className={`reveal ${r.visible ? "in" : ""} text-center mb-12`}>
          <p className="section-sub">{t.gallery.sub}</p>
          <h2 className="section-title text-4xl md:text-5xl mt-3">{t.gallery.title}</h2>
          <div className="ornament mt-4">
            <Camera className="text-[#D4A94A]" size={20} />
          </div>
          <p className="mt-4 text-[#1B1512]/70 max-w-2xl mx-auto">
            {t.gallery.desc}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className="gallery-item aspect-square shadow-md"
              onClick={() => setSelected(img)}
              style={{ animationDelay: `${(i % 8) * 0.05}s` }}
            >
              <img src={img.src} alt={img.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </div>

      {selected && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 fade-in"
          onClick={() => setSelected(null)}
        >
          <button className="absolute top-6 right-6 text-white/90 hover:text-white" onClick={() => setSelected(null)}>
            <X size={32} />
          </button>
          <img src={selected.src} alt={selected.alt} className="max-h-[85vh] max-w-full rounded-lg shadow-2xl zoom-in" />
        </div>
      )}
    </section>
  );
}
